var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useRef, useContext } from "react";
import { useHistory } from "react-router";
import AccountMenu from "./AccountMenu";
import { MAGNIFY_SVG, PLUS_SVG, CHEVRON_LEFT_SVG, PLATFORM_SVG, BPMSUPREME_SVG, BPMSUPREME_WHITE_SVG, VOLUME_2_SVG, VOLUME_1_SVG, VOLUME_0_SVG, BPM_LATINO_LOGO_BLACK_SVG, BPM_LATINO_LOGO_SVG } from "../assets/index";
import { CHEVRON_DOWN_SVG } from '../assets';
import TagsInput from 'react-tagsinput';
import HamburgerMenu from "./HamburgerMenu";
import { ClickAwayListener } from "@material-ui/core";
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import { EditModeContext } from "../context/edit";
import { Button } from "./buttons";
import { UserContext, PlaybackManager, Tooltip } from "..";
import { buildFilterFromArray, DefaultSuggestions } from "../util";
import { AutocompleteRenderInput } from "./SearchAutocomplete";
import { isEmpty } from "lodash";
var HeaderBar = function (_a) {
    var _b, _c;
    var onEditToggle = _a.onEditToggle, theme = _a.theme, onFilterChange = _a.onFilterChange, navItems = _a.navItems, sidebarExpanded = _a.sidebarExpanded, setSidebarExpanded = _a.setSidebarExpanded, onLogout = _a.onLogout, credits = _a.credits, urls = _a.urls, platform = _a.platform;
    var history = useHistory();
    var user = useContext(UserContext);
    var editig = useContext(EditModeContext);
    var editAllowed = user.is_admin && (((_b = user.admin_features) === null || _b === void 0 ? void 0 : _b.features.includesLowercase('sounds:qc')) || ((_c = user.admin_features) === null || _c === void 0 ? void 0 : _c.features.includesLowercase('sounds:all')));
    var _d = useState(true), menuCollapsed = _d[0], setMenuCollapsed = _d[1];
    var _e = useState([]), search = _e[0], _setSearch = _e[1];
    var _f = useState(false), mobileSearchBar = _f[0], setMobileSearchBar = _f[1];
    var _g = useState(false), burgerOpen = _g[0], setBurgerOpen = _g[1];
    var _h = useState(false), searchOpen = _h[0], setSearchOpen = _h[1];
    var _j = useState(false), hasSearch = _j[0], setHasSearch = _j[1];
    var _k = useState(false), justSubmitted = _k[0], setJustSubmitted = _k[1];
    var _l = useState(PlaybackManager.getInstance().getVolume() || 1), volume = _l[0], setVolume = _l[1];
    var _m = useState(false), showVolume = _m[0], setShowVolume = _m[1];
    var prevFilter = buildFilterFromArray(search);
    var tagsInput = useRef(null);
    var _o = React.useState(null), platformAnchorEl = _o[0], setAnchorEl = _o[1];
    var handlePlatformPopoverOpen = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handlePlatformPopoverClose = function () {
        setAnchorEl(null);
    };
    var setSearch = function (search) {
        setSearchOpen(false);
        setHasSearch(false);
        var filter = buildFilterFromArray(search, prevFilter);
        onFilterChange(filter);
        setJustSubmitted(true);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "HeaderBar " + (burgerOpen ? 'burgerOpen' : '') },
            React.createElement("div", { className: "hamburger-container desktop", onClick: function () {
                    if (sidebarExpanded)
                        setSidebarExpanded(false);
                    else
                        setSidebarExpanded(true);
                } },
                React.createElement("div", { className: "hamburger-icon " + (burgerOpen ? 'hide' : '') })),
            React.createElement("img", { src: platform.icon, alt: "", className: "logo-pc", onClick: function () { return history.push('/'); } }),
            React.createElement("img", { className: "logo-mobile no-select no-drag", src: theme === 'light' ? platform.logo_dark : platform.logo_light, alt: "BPM Logo", onClick: function () { return history.push('/'); } }),
            React.createElement("div", { className: "username " + (!burgerOpen ? 'hide' : '') }, user.username || 'Guest'),
            React.createElement("img", { src: MAGNIFY_SVG, alt: "magnifying glass", className: "mobile-magnifying-glass " + (mobileSearchBar || burgerOpen ? 'hide' : ''), onClick: function () {
                    if (mobileSearchBar)
                        setMobileSearchBar(false);
                    else
                        setMobileSearchBar(true);
                } }),
            React.createElement("div", { className: "search-container " + (mobileSearchBar ? 'search-expanded' : '') },
                React.createElement("svg", { className: "magnifying-glass", xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" },
                    React.createElement("path", { d: "M23.809 21.646l-6.205-6.205c1.167-1.605 1.857-3.579 1.857-5.711 0-5.365-4.365-9.73-9.731-9.73-5.365 0-9.73 4.365-9.73 9.73 0 5.366 4.365 9.73 9.73 9.73 2.034 0 3.923-.627 5.487-1.698l6.238 6.238 2.354-2.354zm-20.955-11.916c0-3.792 3.085-6.877 6.877-6.877s6.877 3.085 6.877 6.877-3.085 6.877-6.877 6.877c-3.793 0-6.877-3.085-6.877-6.877z" })),
                React.createElement("div", null,
                    React.createElement(TagsInput, { ref: tagsInput, value: search, onChange: setSearch, className: "search-bar-container", inputProps: {
                            className: 'search-bar',
                            name: 'input',
                            placeholder: 'Search',
                            autoComplete: 'off',
                            type: 'search',
                            show: searchOpen,
                            onChange: function (event) {
                                setHasSearch(Boolean((event.target.value)));
                            },
                            onKeyUp: function (event) {
                                if (justSubmitted) {
                                    setJustSubmitted(false);
                                    return;
                                }
                                if (event.key == 'Enter' && event.target.value == '' && !justSubmitted) {
                                    onFilterChange({});
                                }
                            }
                        }, renderInput: AutocompleteRenderInput, renderTag: function (props) {
                            var tag = props.tag, key = props.key, disabled = props.disabled, onRemove = props.onRemove, classNameRemove = props.classNameRemove, getTagDisplayValue = props.getTagDisplayValue, other = __rest(props, ["tag", "key", "disabled", "onRemove", "classNameRemove", "getTagDisplayValue"]);
                            var display = getTagDisplayValue(tag);
                            var t = DefaultSuggestions.find(function (suggestions) { return display.toLowerCase().startsWith(suggestions.name); });
                            if (t) {
                                return (React.createElement("span", __assign({ key: key }, other),
                                    React.createElement("span", { className: 'tag-key' },
                                        t.name,
                                        " "),
                                    display.substr(t.name.length),
                                    !disabled &&
                                        React.createElement("a", { className: classNameRemove, onClick: function (e) { return onRemove(key); } })));
                            }
                            return (React.createElement("span", __assign({ key: key }, other),
                                display,
                                !disabled &&
                                    React.createElement("a", { className: classNameRemove, onClick: function (e) { return onRemove(key); } })));
                        }, renderLayout: function (tagComponents, inputComponent) {
                            return React.createElement("div", { style: { display: 'flex' } },
                                tagComponents,
                                inputComponent);
                        } }),
                    React.createElement("img", { src: PLUS_SVG, alt: "cancel button", className: "cancel " + (mobileSearchBar || burgerOpen ? '' : 'hide'), onClick: function () {
                            if (mobileSearchBar)
                                setMobileSearchBar(false);
                            else
                                setMobileSearchBar(true);
                        } }),
                    React.createElement("img", { src: PLUS_SVG, alt: "cancel", style: { display: hasSearch ? 'block' : 'none' }, className: "cancel-grey", onClick: function () {
                            setHasSearch(false);
                            _setSearch(search);
                            tagsInput.current && tagsInput.current.clearInput();
                        } }),
                    React.createElement("img", { className: "dropdown-btn " + (searchOpen ? 'reverse' : ''), src: CHEVRON_LEFT_SVG, alt: "dropdown button", onClick: function () {
                            setSearchOpen(!searchOpen);
                        } }))),
            React.createElement("div", { className: "right-container " + (burgerOpen ? 'hide' : '') },
                editAllowed && React.createElement("div", { className: "switch-container " + (mobileSearchBar ? 'hide' : '') },
                    React.createElement("input", { className: "switch", checked: editig, type: "checkbox", onClick: function () {
                            onEditToggle();
                        }, onChange: function () { } }),
                    React.createElement("span", { className: "night-mode-text " + (!editig ? 'fadeToggle' : 'fadeToggle-reverse'), onClick: function () {
                            onEditToggle();
                        } }, "Edit Mode"),
                    React.createElement("span", { className: "light-mode-text " + (editig ? 'fadeToggle' : ''), onClick: function () {
                            onEditToggle();
                        } }, "View Mode")),
                credits && React.createElement(React.Fragment, null,
                    React.createElement(Button, { buttonText: 'Credits', className: "credits-button no-select " + (mobileSearchBar ? 'hide' : ''), onClick: function () { return history.push('/pricing'); } }),
                    React.createElement("div", { className: "tooltip-container" },
                        React.createElement(Tooltip, { text: (credits === null || credits === void 0 ? void 0 : credits.hasAdminAccess) ? 'Admin Access' : function () {
                                return React.createElement(React.Fragment, null,
                                    (credits === null || credits === void 0 ? void 0 : credits.regular) + ' Credits',
                                    " ",
                                    React.createElement("br", null),
                                    (credits === null || credits === void 0 ? void 0 : credits.promo) + ' Promo Credits');
                            } }),
                        React.createElement(Button, { buttonText: credits.hasAdminAccess ? '∞' : (credits.promo + credits.regular).toString(), className: "credits-amount no-select " + (mobileSearchBar ? 'hide' : '') }))),
                isEmpty(urls) ? null :
                    React.createElement(ClickAwayListener, { onClickAway: function () {
                            handlePlatformPopoverClose();
                        } },
                        React.createElement("div", { className: "platform " + (mobileSearchBar ? 'hide' : ''), style: { position: 'relative' }, onClick: function (e) {
                                if (platformAnchorEl) {
                                    handlePlatformPopoverClose();
                                }
                                else {
                                    handlePlatformPopoverOpen(e);
                                }
                            } },
                            React.createElement("img", { src: PLATFORM_SVG }))),
                React.createElement("div", { className: 'platform-selection ' + (platformAnchorEl ? 'slide-down' : 'slide-up') },
                    React.createElement("div", { className: "switch-text" }, "Switch to:"),
                    React.createElement("div", { className: "divider" }),
                    !(urls === null || urls === void 0 ? void 0 : urls.supreme) ? null :
                        React.createElement("div", { className: 'platform-selection-item', onClick: function () {
                                window.open(urls.supreme);
                            } },
                            React.createElement("div", { className: 'img', style: { paddingBottom: 40 } },
                                React.createElement("img", { src: theme == 'dark' ? BPMSUPREME_WHITE_SVG : BPMSUPREME_SVG }))),
                    !(urls === null || urls === void 0 ? void 0 : urls.latino) ? null :
                        React.createElement("div", { className: 'platform-selection-item', onClick: function () {
                                window.open(urls.latino);
                            } },
                            React.createElement("div", { className: 'img' },
                                React.createElement("img", { src: theme == 'dark' ? BPM_LATINO_LOGO_SVG : BPM_LATINO_LOGO_BLACK_SVG })))),
                React.createElement(ClickAwayListener, { onClickAway: function () {
                        setShowVolume(false);
                    } },
                    React.createElement("div", { className: "volume " + (mobileSearchBar ? 'hide' : ''), style: { position: 'relative' } },
                        React.createElement("img", { className: "opacity-control", onClick: function (e) {
                                setShowVolume(!showVolume);
                            }, src: (volume > 0) ? (volume > 0.5 ? VOLUME_2_SVG : VOLUME_1_SVG) : VOLUME_0_SVG, height: 23 }),
                        React.createElement("div", { className: 'volume-slider ' + (showVolume ? 'slide-down' : 'slide-up') },
                            React.createElement("div", { className: "volume-control my-auto" },
                                React.createElement(Slider, { vertical: true, min: 0, max: 1, step: .02, value: volume, onChange: function (e) {
                                        setVolume(e);
                                        PlaybackManager.getInstance().setVolume(e);
                                    } }))))),
                React.createElement(ClickAwayListener, { onClickAway: function () {
                        setMenuCollapsed(true);
                    } },
                    React.createElement("div", { className: "account-container flex", style: { alignItems: "center" } },
                        React.createElement("img", { className: "avatar", src: user.profile_image_thumbnail_url || platform.icon, onClick: function () {
                                if (menuCollapsed)
                                    setMenuCollapsed(false);
                                else
                                    setMenuCollapsed(true);
                            }, alt: "BPM Avatar" }),
                        React.createElement("div", { className: "avatar-dropdown-container no-select", onClick: function () {
                                if (menuCollapsed)
                                    setMenuCollapsed(false);
                                else
                                    setMenuCollapsed(true);
                            } },
                            React.createElement("img", { className: "chevron", src: CHEVRON_DOWN_SVG, alt: "Dropdown Menu Chevron" }),
                            React.createElement(AccountMenu, { expanded: !menuCollapsed, onLogout: onLogout, isFullScreen: document.webkitIsFullScreen || document.msFullscreenElement || document.fullscreen, onEnterFullScreen: (document.fullscreenEnabled || document.webkitFullscreenEnabled ||
                                    document.mozFullScreenEnabled ||
                                    document.msFullscreenEnabled) ? function () {
                                    var docElm = document.documentElement;
                                    if (document.webkitIsFullScreen || document.msFullscreenElement || document.fullscreen) {
                                        try {
                                            if (document.exitFullscreen) {
                                                document.exitFullscreen();
                                            }
                                            else if (document.mozCancelFullScreen) {
                                                document.mozCancelFullScreen();
                                            }
                                            else if (document.webkitCancelFullScreen) {
                                                document.webkitCancelFullScreen();
                                            }
                                            else if (document.msExitFullscreen) {
                                                document.msExitFullscreen();
                                            }
                                        }
                                        catch (error) {
                                        }
                                    }
                                    else {
                                        try {
                                            if (docElm.requestFullscreen) {
                                                docElm.requestFullscreen();
                                            }
                                            else if (docElm.mozRequestFullScreen) {
                                                docElm.mozRequestFullScreen();
                                            }
                                            else if (docElm.webkitRequestFullScreen) {
                                                docElm.webkitRequestFullScreen();
                                            }
                                            else if (docElm.msRequestFullscreen) {
                                                docElm.msRequestFullscreen();
                                            }
                                        }
                                        catch (error) {
                                        }
                                    }
                                } : undefined }))))),
            React.createElement("img", { className: "mobile-cancel " + (burgerOpen ? '' : 'hide'), src: PLUS_SVG, alt: "cancel button", onClick: function () {
                    setBurgerOpen(false);
                } }),
            React.createElement("div", { className: "hamburger-container " + (mobileSearchBar ? 'hide' : ''), onClick: function () { return setBurgerOpen(true); } },
                React.createElement("div", { className: "hamburger-icon " + (burgerOpen ? 'hide' : ''), onClick: function () { return setBurgerOpen(true); } }))),
        React.createElement(HamburgerMenu, { navItems: navItems, burgerOpen: burgerOpen })));
};
export default HeaderBar;
//# sourceMappingURL=HeaderBar.js.map